import { Component, OnInit, ViewChild } from '@angular/core';
import { grupoProducto } from '../grupoProducto';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { GrupoProductoService } from '../grupoProducto.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Canales } from '../canales';
import { CanalesService } from '../canales.service';
import { AlertService } from 'ngx-alerts';

@Component({
  selector: 'app-canales',
  templateUrl: './canales.component.html',
  styleUrls: ['./canales.component.css']
})
export class CanalesComponent implements OnInit {


  grupos: grupoProducto[];
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective
  @ViewChild('processingModal') public mdbModal: ModalDirective;
  editForm: FormGroup;
  canales: Canales[] = [];
  lista: Canales[] = [];
  previous: any = [];
  canal: Canales;
  isLoadingResults = true;

  constructor(

    cconfig: NgbModalConfig,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private apiGrupo: GrupoProductoService,
    private api: CanalesService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
  ) {


  }



  ngOnInit(): void {
    this.listarGrupos()
    this.listarCanales()

    this.editForm = this.formBuilder.group({
      lote: ['', Validators.required],

      id: [0, Validators.required],
      tipoId: [0, Validators.required],
      pesoProcesado: [0, Validators.required],
      pesoComprado: [0, Validators.required],
      merma: [0, Validators.required],
      valor: [0, Validators.required],

    });

  }



  editar(canal: Canales) {
    this.editForm.controls.id.setValue(canal.id)
    this.editForm.controls.lote.setValue(canal.lote)
    this.editForm.controls.merma.setValue(canal.merma)
    this.editForm.controls.pesoComprado.setValue(canal.pesoCompra)
    this.editForm.controls.pesoProcesado.setValue(canal.pesoProcesado)
    this.editForm.controls.tipoId.setValue(canal.tipoId)
    this.editForm.controls.tipoId.setValue(canal.tipoId)
    this.editForm.controls.valor.setValue(canal.valor)
    this.mdbModal.show();

  }



  actulizar() {
    this.canal = new Canales();
    this.canal.id = this.editForm.controls.id.value;
    this.canal.lote = this.editForm.controls.lote.value;
    this.canal.merma = this.editForm.controls.merma.value;
    this.canal.pesoCompra = this.editForm.controls.pesoComprado.value;
    this.canal.pesoProcesado = this.editForm.controls.pesoProcesado.value;
    this.canal.tipoId = this.editForm.controls.tipoId.value;
    this.canal.valor = this.editForm.controls.valor.value;
    this.canal.idEmisor = Number(localStorage.getItem('id'));
    // Limpias el arreglo y agregas el objeto
    this.canales = [];
    this.canales.push(this.canal);

    this.api.setActulizar(this.canales).subscribe(

      data => {
        this.alertService.success("Se actualizo con exito..")
        this.mdbModal.hide();
        this.listarCanales();

      },

      error => {

        this.alertService.danger(error)

      }

    );



  }


  eliminar(id: number) {
    this.api.eliminar(id).subscribe(

      data => {
        this.alertService.success("Se elimino con exito..")
        this.listarCanales();


      },

      error => {

        this.alertService.danger(error)

      }

    );

  }

  listarCanales() {

    this.api.listarPorEmisor(localStorage.getItem('id'))
      .subscribe((
        data: Canales[]) => {
        this.lista = data;
        console.log(this.lista);
        this.mdbTable.setDataSource(this.lista);
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
      }
        , err => {
          console.log(err);
          this.isLoadingResults = false;
        });

  }




  agregar() {
    this.editForm = this.formBuilder.group({
      lote: ['', Validators.required],

      id: [0, Validators.required],
      tipoId: [0, Validators.required],
      pesoProcesado: [0, Validators.required],
      pesoComprado: [0, Validators.required],
      merma: [0, Validators.required],
      valor: [0, Validators.required],
    });

    this.mdbModal.show();

  }

  listarGrupos() {

    this.apiGrupo.getGrupo(localStorage.getItem('id')).subscribe((
      data: grupoProducto[]) => {
      this.grupos = data;
      console.log(this.grupos);

    }
      , err => {
        console.log(err);

      });

  }


}
